export const type = 'form.multiSelect';
